import React from 'react';
import { themes } from './themes';

const ThemeSelector = ({ selectedTheme, onSelectTheme }) => (
  <div className="flex items-center gap-2 overflow-x-auto pb-1">
    {Object.entries(themes).map(([key, t]) => (
      <button
        key={key}
        data-testid={`theme-${key}`}
        onClick={() => onSelectTheme(key)}
        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border-2 text-[11px] font-sans font-medium whitespace-nowrap transition-all ${
          selectedTheme === key ? 'border-primary bg-primary/5' : 'border-stone-100 hover:border-stone-200'
        }`}
      >
        <div className="flex gap-px">
          <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: t.accent }} />
          <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: t.bg }} />
        </div>
        {t.name}
      </button>
    ))}
  </div>
);

export default ThemeSelector;
